/**
 * Block: Video Quote
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-scripts/#build for build info.
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata for block.json information.
 *
 */
import "./video-quote.scss";
jQuery(document).ready(function ($) {
  window.loadThumbnail = function (wistiaID) {
    $.get(
      "https://fast.wistia.net/oembed?url=http://home.wistia.com/medias/" +
        wistiaID,
      function (data) {
        const thumbnail_url = data.thumbnail_url;
        $("#wistia-thumbnail").attr("src", thumbnail_url);
        $("#wistia-embed").html(data.html);
      }
    );
  };
});
